import { render, staticRenderFns } from "./ValList.vue?vue&type=template&id=bf0d5672&scoped=true"
import script from "./ValList.vue?vue&type=script&lang=js"
export * from "./ValList.vue?vue&type=script&lang=js"
import style0 from "./ValList.vue?vue&type=style&index=0&id=bf0d5672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0d5672",
  null
  
)

export default component.exports